<div [hidden]="hideButtons" *ngIf="togoMode ? true : party?.checkin_time" class="flex">
  <button
    *ngIf="voicePageNotificationEnabled && !togoMode"
    class="btn btn-info-outline btn-icon mr-2"
    placement="top"
    container="body"
    [ngbTooltip]="!isMobile ? 'Call' : ''"
    (click)="notifyActions?.voicePage(party)"
    (mousedown)="callBtnFocus[index] = true"
    (mouseup)="callBtnFocus[index] = false"
    [disabled]="notifyActions?.disableMessageButton(party)"
    angularticsCategory="waitlist"
    id="call-party-{{index}}"
    angulartics2On="click"
    angularticsAction="sent ready call">
    <tr-icon [icon]="icon.call" [color]="callBtnFocus[index] ? color.white : color.blue" classes="icon-secondary"></tr-icon>
  </button>
  <button
    class="btn btn-info btn-icon"
    placement="top"
    container="body"
    [ngbTooltip]="!isMobile ? 'Text' : ''"
    (click)="notifyActions?.smsPage(party)" id="text-party-{{index}}"
    [disabled]="notifyActions?.disableMessageButton(party)"
    angularticsCategory="waitlist"
    angulartics2On="click"
    angularticsAction="sent ready sms">
    <tr-icon [icon]="icon.send" [white]="true"></tr-icon>
  </button>
</div>

<ul class="list-unstyled tr-icon-list mb-1 mt-2">
  <li
    *ngFor="let msg of notifyActions?.mergeInboundOutbound(party)"
    [ngClass]="{'danger':!msg.label}"
    class="d-flex flex-row align-items-center"
  >
    <ng-container *ngIf="!msg.label || msg.type === 'voice' || [notificationLabelsEnum.chat, notificationLabelsEnum.ready, notificationLabelsEnum.toGoOrderReady].includes(msg.label) || msg.status_sent === 'not_sent'">
      <div *ngIf="msg.status_sent === 'inProcess' && msg.time >= (now - 60000)" class="mr-2">
        <tr-loader [isSpinner]="true"></tr-loader>
      </div>
      <tr-icon *ngIf="msg.status_sent === 'sent'" [icon]="icon.complete" classes="tr-bullet mr-2"></tr-icon>
      <tr-icon
        *ngIf="msg.status_sent === 'not_sent' || (msg.status_sent === 'inProcess' && msg.time < (now - 60000))"
        classes="tr-bullet mr-2"
        [icon]="icon.exclamation"
      ></tr-icon>
      <tr-icon *ngIf="!msg.label" [icon]="icon.send" classes="tr-bullet mr-2"></tr-icon>
      <span>
        <span *ngIf="msg.label && msg?.label !== 'chat'">
          {{msg.label | notificationLabel | titlecase}} {{msg.type | prettifyNotificationType}}
        </span>
        <span *ngIf="!msg.label || msg.label === 'chat'" [innerHTML]="(msg?.Body || msg?.message)"></span>
        <span *ngIf="notificationTime === notificationTimeEnum.Absolute" class="ml-1"> ({{ msg.time | trDateFormat:'M/D h:mm a': timezone}})</span>
        <span *ngIf="notificationTime === notificationTimeEnum.Relative" class="ml-1"> ({{ (now - msg.time) | trTimeDelta }} ago)</span>
      </span>
    </ng-container>
  </li>
</ul>
